"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const authenticated_client_1 = require("./authenticated.client");
class NewCrudClient extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.version = 'v1';
        this.entityPath = '';
        this.urlTemplate = `/:version/projects/:project/:entity`;
    }
    getById(key, fields) {
        return __awaiter(this, void 0, void 0, function* () {
            const id = typeof key === 'object' ? key.id : +key;
            const url = this.getPath(key, id, { fields });
            const response = yield this.httpGet(url, { returnNullOn404: true, throwOnError: true });
            return response.payload;
        });
    }
    search(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.getPath(parameters, null, parameters);
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    update(key, entity) {
        return __awaiter(this, void 0, void 0, function* () {
            const id = typeof key === 'object' ? key.id : +key;
            const url = this.getPath(key, id);
            const response = yield this.httpPut(url, entity);
            return response.payload;
        });
    }
    create(entity) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.getPath(entity);
            const response = yield this.httpPost(url, entity);
            return response.payload;
        });
    }
    delete(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.getPath(key, typeof key === 'number' ? key : null);
            yield this.httpDelete(url);
        });
    }
    getPath(key, path, parameters) {
        var _a, _b;
        let result = this.urlTemplate
            .replace(':version', this.version)
            .replace(':project', (_a = key.projectId) === null || _a === void 0 ? void 0 : _a.toString())
            .replace(':user', (_b = key.user) === null || _b === void 0 ? void 0 : _b.toString())
            .replace(':entity', this.entityPath);
        path = (path && path.toString());
        if (path && path[0] === '/') {
            result += path;
        }
        else if (path) {
            result += `/${path}`;
        }
        if (parameters) {
            result += `?${this.getQueryString(parameters)}`;
        }
        return result;
    }
}
exports.NewCrudClient = NewCrudClient;
//# sourceMappingURL=new.crud.client.js.map